class GiftController {
    constructor() {
        this.cart = {};
        this.gifts = [];
        this.hasGifts = [];

        this.elements = {
            giftsJson: document.querySelector('[data-gifts-json]'),
            checkoutButton: document.querySelector('.js-cart [name="checkout"]'),
        }

        this.init();
    }

    init() {
        this.getGifts();
        this.fetchCart().then((hasCart) => {
            if (hasCart) {
                if (this.elements.checkoutButton) {
                    this.elements.checkoutButton.addEventListener('click', () => {
                        this.handleAddToCart();
                    });
                }
            }
        });
    }

    cartHasAllGifts() {
        this.cart.items.forEach((item) => {
            this.gifts.forEach((gift) => {
                if (item.variant_id === gift.variants[0].id) {
                    this.hasGifts.push(true);
                } else {
                    this.hasGifts.push(false);
                }
            });
        });

        // number of true values in array must be equal to number of gifts
        if (this.hasGifts.filter(
            (value) => value === true
        ).length === this.gifts.length) {
            return true;
        } else {
            return false;
        }
    }

    async fetchCart() {
        return fetch('/cart.js')
            .then((response) => response.json())
            .then((data) => {
                this.cart = data
                return data != null;
            });
    }

    getGifts() {
        if (this.elements.giftsJson) {
            this.gifts = JSON.parse(this.elements.giftsJson.innerHTML).gifts;
        }
    }

    removeGiftsFromCart() {
        const items = this.gifts.map((item) => {
            return {
                id: item.variants[0].id,
                quantity: 0,
            }
        });

        let itemUpdates = {};

        items.forEach((item) => {
            itemUpdates[item.id] = item.quantity;
        });

        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                updates: itemUpdates,
            }),
        }).then((response) => response.json()).then(() => {
            console.log('removed gifts from cart', window.location.pathname);
            if(window.location.pathname != '/cart') {
                window.location.href = '/cart';
            }
        });
    }


    handleAddToCart() {
        const country = Shopify.country;

        if (this.cartHasAllGifts()) {
            if(window.location.pathname != '/cart') {
                window.location.href = '/cart';
            }
        } else {
            if (country === 'HR') {
                if (window.location.pathname !== '/cart') {
                    this.addGiftsToCart();
                }
            } else {
                this.removeGiftsFromCart();
            }
        }
    }

    addGiftsToCart() {
        const items = this.gifts.map((gift) => {
            return {
                id: gift.variants[0].id,
                quantity: 1,
                properties: {
                    'Note': gift.line_item_note
                }
            }
        });

        let itemUpdates = {};

        items.forEach((item) => {
            itemUpdates[item.id] = item.quantity;
        });

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                items: items,
            }),
        })
            .then((response) => response.json())
            .then(() => {

                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        updates: itemUpdates,
                    }),
                })
                    .then((response) => response.json())
                    .then(() => {
                        console.log('added gifts to cart', window.location.pathname);
                        if(window.location.pathname != '/cart') {
                            window.location.href = '/cart';
                        }
                    });
            });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.giftController = new GiftController();
});